import { render, staticRenderFns } from "./products_card.vue?vue&type=template&id=4abc2ec0&scoped=true&"
import script from "./products_card.vue?vue&type=script&lang=js&"
export * from "./products_card.vue?vue&type=script&lang=js&"
import style0 from "./products_card.vue?vue&type=style&index=0&id=4abc2ec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abc2ec0",
  null
  
)

export default component.exports